import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBox2AltFill: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="box-2-alt-fill, inbox, archive, tray, shelf"><path d="M3.75 12.75H8.0702C8.3 14.6006 10.0472 16 12 16C13.9528 16 15.7 14.6006 15.9298 12.75L20.25 12.75M3.75 20.25H20.25V3.75L3.75005 3.75001L3.75 20.25Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconBox2AltFill;
